/**
 * Returns the environment specific publishable (public) key
 * for making Stripe front-end requests on behalf of Appointedd.
 */
export const getStripePublishableKey = (): string => {
  const runtimeEnv = process.env.RUNTIME_ENV ?? "development";

  /**
   * Development, T1 & T2 all currently share the same Stripe publishable key.
   */
  const developmentPublishableKey = "pk_test_W0w3TSmRfuQghrNSg17SlRuO";

  // These code paths can never be hit by tests
  /* istanbul ignore next */
  if (runtimeEnv === "production") {
    return "pk_live_OArhBQkKJSzF1xUmV1Aqfbny";
  } else if (runtimeEnv === "t2") {
    return developmentPublishableKey;
  } else if (runtimeEnv === "t1") {
    return developmentPublishableKey;
  }

  return developmentPublishableKey;
};
